import {h, Component} from 'preact'
import FontPageStore from '../actions/actions'

export function getFontUrl (attrs, cache = false) {
  const args = []
  for (let key in attrs) {
    args.push(`${key}=${encodeURIComponent(attrs[key])}`)
  }
  return '/fontgen/?' + args.join('&')
}

export default class FontImage extends Component {
  constructor (props) {
    super(props)
    this.state = { pixelRatio: window.devicePixelRatio || 1 }
    this.state.src = this.makeSrc(props)
    this.state.isLoading = true
    this.state.isInError = false
  }

  makeSrc (props) {
    const {state} = this
    return getFontUrl({
      pid: props.id,
      ps:  props.pointSize,
      wi:  props.width,
      hi:  props.height,
      bc:  props.backgroundColor,
      fc:  props.foregroundColor,
      bco: props.backgroundOpacity,
      pt:  props.paddingTop,
      pl:  props.paddingLeft,
      rm:  (props.pixelRatio === 'auto')
        ? state.pixelRatio
        : props.pixelRatio,
      t:   props.text,
    }, props.cache)
  }

  componentWillMount () {
    window.addEventListener('resize', this.handleResize)
  }
  componentDidMount () {
    const {props, state, image} = this
    if (image && image.complete) {
      if (state.isLoading) {
        this.setState({ isLoading: false })
      }
    } else if (props.onLoadStart) {
      props.onLoadStart(state.src)
    }
  }
  componentWillUnmount () {
    const {props, state} = this
    if (state.isLoading && props.onLoadAbort) {
      props.onLoadAbort(state.src)
    }
  }

  handleResize = (event) => {
    this.setState({
      pixelRatio: window.devicePixelRatio || 1
    })
  }

  componentWillReceiveProps (newProps) {
    const src = this.makeSrc(newProps)
    if (src !== this.state.src) {
      if (this.state.isLoading && this.props.onLoadAbort) {
        this.props.onLoadAbort(this.state.src)
      }
      this.setState({
        isLoading: true,
        isInError: false,
        src: src
      })
      if (this.props.onLoadStart) {
        this.props.onLoadStart(src)
      }
    }
  }

  handleLoad = (event) => {
    this.setState({ isLoading: false })
    if (this.props.onLoad) {
      this.props.onLoad(this.state.src)
    }
  }

  handleError = (event) => {
    this.setState({ isLoading: false, isInError: true })
    if (this.props.onLoadError) {
      this.props.onLoadError(this.state.src)
    }
  }

  handleRef = (image) => {
    this.image = image
  }

  isComplete = () => {
    return this.image.complete
  }

  render () {
    const {props, state} = this
    return <img className="font-preview" width={props.width} height={props.height}
     onLoad={this.handleLoad} onError={this.handleError} style={{ opacity: state.isLoading ? .1 : 1 }}
      alt={props.text} src={state.src} ref={this.handleRef} />
  }

  static defaultProps = {
    width: 864,
    height: 160,
    pointSize: 72,
    backgroundColor: 'ffffff',
    foregroundColor: '000000',
    backgroundOpacity: '0',
    paddingTop: 0,
    paddingLeft: 0,
    cache: true,
    pixelRatio: 'auto',
    text: 'Terminal Design'
  }
}



// WEBPACK FOOTER //
// ./inc/js/components/FontImage.js